export default __webpack_public_path__ + "static/media/arrow_right.404397dc.svg";